import InputText from '@/core/Input/InputText';
import InputNumber from '@/core/Input/InputNumber';

export default function Step1({ formikSignUpRealestate, handleSubmitAttempt }) {
  return (
    <form
      onSubmit={handleSubmitAttempt}
      className="grid grid-cols-2 gap-x-4 gap-y-8 lg:gap-x-6 lg:gap-y-10 w-full max-w-[550px] place-items-start"
    >
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-1 w-full">
        <InputText
          name="firstName"
          title="نام مدیر آژانس"
          placeholder="مثال : امیر رضا"
          value={formikSignUpRealestate.values.firstName}
          errors={formikSignUpRealestate.errors.firstName}
          touched={formikSignUpRealestate.touched.firstName}
          handleBlur={formikSignUpRealestate.handleBlur}
          handleChange={formikSignUpRealestate.handleChange}
        />
      </div>
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-1 w-full">
        <InputText
          name="lastName"
          title="نام خانوادگی مدیر آژانس"
          placeholder="مثال : خسروی"
          value={formikSignUpRealestate.values.lastName}
          errors={formikSignUpRealestate.errors.lastName}
          touched={formikSignUpRealestate.touched.lastName}
          handleBlur={formikSignUpRealestate.handleBlur}
          handleChange={formikSignUpRealestate.handleChange}
        />
      </div>
      <div className="flex flex-col relative gap-1 col-span-2 w-full">
        <InputNumber
          name="nationalID"
          title="کد ملی مدیر آژانس"
          placeholder="باید 10 رقم باشد"
          value={formikSignUpRealestate.values.nationalID}
          errors={formikSignUpRealestate.errors.nationalID}
          touched={formikSignUpRealestate.touched.nationalID}
          handleBlur={formikSignUpRealestate.handleBlur}
          handleChange={formikSignUpRealestate.handleChange}
        />
      </div>
      <div className="sm:col-span-1 col-span-2 max-sm:w-full">
        <button type="submit" className="btn btn-primary max-sm:w-full">
          تایید و ادامه
        </button>
      </div>
    </form>
  );
}
